import { useMemo } from "react";
import Transfer from "../../components/modals/Transfer";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useTransferModal = () => {
    const { open, close, visible, selected } = useVisible();

    const modal = useMemo(() => {
        return (
            <Transfer 
                visible={visible}
                close={close}
                values={selected}
            />
        );
    }, [visible, close, selected]);

    return { open, modal };
}
